<template>
  <div id="sidebar-drawer" class="flex absolute top-0 right-0 h-full lg:relative"></div>
</template>
